const CUSTOMER_PLAN_LABELS: Record<string, string> = {
  free: 'Free',
  standard: 'Standard',
  standard_india: 'Standard',
  byok: 'BYOK',
  plus: 'Plus',
  pro: 'Pro',
  unlimited: 'Unlimited',
};

export const normalizePlanTier = (tier?: string | null): string => (tier || 'free').trim().toLowerCase();

const NEXT_PLAN_LABEL_BY_TIER: Record<string, string> = {
  free: 'standard',
  trial: 'standard',
  standard: 'plus',
  standard_india: 'plus',
  byok: 'plus',
  plus: 'pro',
  pro: 'unlimited',
};

/** The plan an upgrade leads to, or undefined when the tier is already the top one. */
export const getNextPlanLabel = (tier?: string | null): string | undefined => (
  NEXT_PLAN_LABEL_BY_TIER[normalizePlanTier(tier)]
);

export const getCustomerPlanLabel = (tier?: string | null): string => {
  const normalized = normalizePlanTier(tier);
  const knownLabel = CUSTOMER_PLAN_LABELS[normalized];
  if (knownLabel) return knownLabel;

  return normalized
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

export const getPlanBadgeClass = (tier?: string | null): string => (
  normalizePlanTier(tier).replace(/[^a-z0-9_-]/g, '-')
);
